import React, { useState, useEffect } from 'react';
import { MwInputFile, MwSelectorProduct, MwButton, MwSpinner, MwSelector } from '../ui';
import { FaTimes, FaPlus, FaRegSave, FaExchangeAlt, FaArrowDown, FaArrowUp } from 'react-icons/fa';
import { useCurrent, useFetch, usePut, useUploadFile } from '../../hooks';
import { useNavigate, useParams } from 'react-router-dom';
import { toast , ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CardHeadeWithActions from './../ui/CardHeadeWithActions';
import useDeleteWBody from './../../hooks/useDeleteWBody';
import OsMwSelectorAccount from './RequisitionComponents/OsMwSelectorAccount';
import { useTranslation } from 'react-i18next'

const OsRequisitionViewUpdate = () => {
  const [t,i18n ] = useTranslation('global')
  const { requisitionid } = useParams();
    const { tenant } = useParams();  
    const navigate=useNavigate() 
  // States for form fields
  const [selectedFile, setSelectedFile] = useState(null);
    const [fileKey, setFileKey] = useState(null);
  const [rows, setRows] = useState([]);
  const [subAccount, setSubAccount] = useState('');
  const [warehouses, setWarehouses] = useState([]);
  const [reqNo, setReqNo] = useState('');
  const [reqNote, setReqNote] = useState('');
  const [reqAttach, setReqAttach] = useState(null);
  const [reqDate, setReqDate] = useState(new Date().toISOString().split('T')[0]);
  const [fromWarehouse, setFromWarehouse] = useState(null);
  const [toWarehouse, setToWarehouse] = useState(null);
  const [reqType, setReqType] = useState('');
  const [initialData, setInitialData] = useState(null);  
  const [HasChanges, setHasChanges] = useState(false);  
   const [fileLocation, setFileLocation] = useState(null);
    const isRTL = i18n.dir() === 'rtl'
 
  // Custom hooks for fetching and updating data
  const { currentTenantId, currentCompanyId, currentBranchId, userName } = useCurrent();
  const { data:putdata ,putData, loading: putLoading, error: putError } = usePut();
  // Fetch requisition data by ID
  const requisitionUrl = `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/requisitions/master/${requisitionid}`;
  const { data: requisitionData, loading: requisitionLoading, error: requisitionError } = useFetch(requisitionUrl);
  console.log('account_no',requisitionData?.data?.account_no)
  const getFileNameFromUrl = (url) => {
    if (!url) return '';
    const parts = url.split('/');
    const fullFileName = parts[parts.length - 1];
    // إزالة GUID من اسم الملف إذا وجد
    const nameWithoutGuid = fullFileName.split('-').slice(1).join('-');
    return decodeURIComponent(nameWithoutGuid);
  };
  
  useEffect(() => {
    if (reqType === 'TRANS') {
      setToWarehouse(''); // إعادة تعيين حقل "إلى" عند تغيير حقل "من"
    }
  }, [fromWarehouse, reqType]);
  // Fetch warehouses data
  const warehousesUrl = `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/warehouses/${currentTenantId}/${currentCompanyId}/${currentBranchId}`;
  const { data: warehousesData, loading: warehousesLoading, error: warehousesError } = useFetch(warehousesUrl);
 
  // Set warehouses data when fetched
  useEffect(() => {
    if (warehousesData && warehousesData.data) {
      setWarehouses(warehousesData.data);
    }
  }, [warehousesData]);

  // Set requisition data when fetched
  useEffect(() => {
    if (requisitionData && requisitionData.data) {
      const data = requisitionData.data;
      
      // تعديل البيانات الأولية لتتضمن سعر الشراء المحسوب
      const modifiedData = {
        ...data,
        details: data.details.map(item => {
          const qty = parseFloat(item.qty) || 0;
          const total = parseFloat(item.total) || 0;
          const calculatedUnitPrice = qty !== 0 && total !== 0 ? total / qty : '';
          return {
            ...item,
            cost: calculatedUnitPrice  // تحديث سعر الشراء في البيانات الأولية
          };
        })
      };
      
      // حفظ البيانات الأولية المعدلة
      setInitialData(modifiedData);
      
      // Set other state values
      setReqNo(data.req_no || '');
      setReqNote(data.req_note || '');
      setReqDate((data.req_date || '').split(' ')[0]);
      setReqType(data.req_type || '');
      setFromWarehouse(data.warehouse_id || '');
      setToWarehouse(data.warehouse_id_to || '');
      setSubAccount(data.account_no || '');

      if (data.req_attach) {
        const fileExtension = data.req_attach.split('.').pop().toLowerCase();
        const fileType = fileExtension === 'pdf' ? 'application/pdf' : 'image/*';
        
        setFileKey(data.req_attach);
        setFileLocation(data.req_attach);
        setSelectedFile({
          name: data.req_attach.split('/').pop(), 
          type: fileType,
          url: data.req_attach
        });
      }
      if (data.details && data.details.length > 0) {
        const normalizedRows = data.details.map((item) => {
          const qty = parseFloat(item.qty) || 0;
          const total = parseFloat(item.total) || 0;
          const calculatedUnitPrice = qty !== 0 && total !== 0 ? total / qty : '';
          
          return {
            item: item.product_name || '',
            product_id: item.product_id || '',
            product_uom_id: item.product_uom_id || '',
            product_uom_name: item.product_uom_name || '',
            product_uom_template_id: item.product_uom_template_id || '',
            quantity: qty,
            balanceBefore: item.balance_before || 0,
            balanceAfter: item.balance_after || 0,
            unitPrice: calculatedUnitPrice,
            total: total
          };
        });
        setRows(normalizedRows);
      }
    }
  }, [requisitionData]);

  
 
  const handleUpdate = async () => {
    if (!validateFields()) {
      toast.error( t('deleted.fill_required_fields') , {
        position: "top-center",
        autoClose: 3000,
        rtl: true,
        theme: "colored",
      });
      return;
    }

    const updatedData = {
      warehouse_id: fromWarehouse,
      warehouse_id_to: Number( toWarehouse) || null, 
      // reqType === 'TRANS' && fromWarehouse === toWarehouse ? toWarehouse : null,
      req_type: reqType,
      req_no: reqNo,
      req_note: reqNote,
      req_attach: fileKey,
      req_status: 1,
      req_date: reqDate,
      account_no:subAccount,
      items: rows.map((row) => ({
        requisition_master_id: requisitionid, // requisitionid
        product_id: row.product_id,
        product_name: row.item,
        product_uom_id: row.product_uom_id,
        product_uom_name: row.product_uom_name,
        product_uom_template_id: row.product_uom_template_id,
        qty: row.quantity,
        balance_before: row.balanceBefore,
        balance_after: row.balanceAfter,
        total: row.total,
      })),
    };
    console.log('updatedData' ,updatedData)
    await putData(requisitionUrl, updatedData);
  };

  // Add a new row to the items table
  const addRow = () => {
    const lastRow = rows[rows.length - 1];
   
    if (lastRow && (!lastRow.item || !lastRow.quantity)) {
      toast.error(t('deleted.fill_current_row_fields'), {
        position: "top-center",
        autoClose: 3000,
        rtl: true,
        theme: "colored",
      });
      return;
    }

    setRows([
      ...rows,
      {
        item: '',
        product_id: '',
        product_uom_id: '',
        product_uom_name: '',
        product_uom_template_id: '',
        quantity: '',
        balanceBefore: 0,
        balanceAfter: 0,
        total: 0,
      },
    ]);
  };

  // Remove a row from the items table
  const removeRow = (index) => {
    const newRows = rows.filter((_, i) => i !== index);
    setRows(newRows);
  };

  // Handle input changes for each row
  const handleInputChange = (index, field, value) => {
    const newRows = [...rows];
    newRows[index][field] = value;
  
    if (field === 'quantity') {
      const quantity = parseFloat(value) || 0;
      const balanceBefore = parseFloat(newRows[index].balanceBefore) || 0;
      const unitPrice = parseFloat(newRows[index].unitPrice) || 0;
      newRows[index].balanceAfter = balanceBefore + quantity;
      newRows[index].total = quantity * unitPrice;
    }
  
    if (field === 'unitPrice') {
      const quantity = parseFloat(newRows[index].quantity) || 0;
      const unitPrice = value === '' ? '' : parseFloat(value) || 0;
      newRows[index].total = unitPrice === '' ? 0 : quantity * unitPrice;
    }
  
    setRows(newRows);
  };

  const handleProductSelect = (selectedProduct, index) => {
    // التحقق من وجود المنتج المحدد
    if (selectedProduct && selectedProduct._id) {
      // التعامل مع مصفوفة أسماء المنتجات وأوصافه، مع وضع مصفوفة فارغة كقيمة افتراضية
      const productName = selectedProduct.productName || [];
      const productDesc = selectedProduct.productDesc || [];
  
      // الحصول على اسم المنتج باللغة الإنجليزية أولاً، ثم العربية إذا لم يجد الإنجليزية
      const productNameText = productName.find((name) => name.lang === 'en')?.text || 
                            productName.find((name) => name.lang === 'ar')?.text 
                            // || 'منتج بدون اسم'; // قيمة افتراضية إذا لم يجد أي اسم
 
      // الحصول على معرف المنتج من العنصر الأول أو الثاني في مصفوفة الأسماء
      const productId = selectedProduct._id || ''; // استخدام معرف المنتج الرئيسي
      
      // باقي البيانات غير مهمة للتحقق
      const productUomId = selectedProduct.uomPurchase?.id || '';
      const productUomName = selectedProduct.uomPurchase?.short_name || '';
      const productUomTemplateId = selectedProduct.uomTemplate?.id || '';
      const balanceBefore = selectedProduct.qty || 0;
      const cost = selectedProduct.cost || 0;
  
      const newRows = [...rows];
      const quantity = newRows[index].quantity || 0;
      const total = cost * quantity;
  
      newRows[index] = {
        ...newRows[index],
        // القيم الأساسية المطلوبة (اسم المنتج ومعرفه)
        item: productNameText,
        product_id: productId,
        // باقي القيم
        product_uom_id: productUomId,
        product_uom_name: productUomName,
        product_uom_template_id: productUomTemplateId,
        balanceBefore: balanceBefore,
        balanceAfter: balanceBefore + quantity,
        unitPrice: cost,
        total: total,
      };
      setRows(newRows);
    }
  };

  // Format numbers to two decimal places
  const formatNumber = (number) => {
    return Number(number).toFixed(2);
  };

  // Validate fields
  const validateFields = () => {
    // Check required fields
    if (!reqDate || !fromWarehouse || !reqType || !reqNo) {
      return false;
    }

    if (reqType === 'TRANS' && (!toWarehouse || toWarehouse === '')) {
      return false;
    }
  
    // Special validation for transfer type
    if (reqType === 'TRANS' && (!toWarehouse || toWarehouse === '')) {
      return false;
    }
  
    // Check if there are any rows
    if (rows.length === 0) {
      return false;
    }
  
    // Validate each row
    for (const row of rows) {
      if (!row.product_id || !row.quantity) {
        return false;
      }
    }
  
    return true;
  };
  const isModified = () => {
    if (!initialData) return false;

    // Helper function to safely compare values that might be null/undefined
    const safeCompare = (val1, val2) => {
      // Convert empty strings, null, and undefined to consistent values
      const normalize = (value) => {
        if (value === null || value === undefined || value === '') return '';
        return String(value).trim();
      };
      return normalize(val1) !== normalize(val2);
    };

    // Helper function to safely compare numbers
    const safeCompareNumbers = (val1, val2) => {
      const num1 = Number(val1) || 0;
      const num2 = Number(val2) || 0;
      return Math.abs(num1 - num2) > 0.001; // Using small epsilon for float comparison
    };

    // Compare basic fields
    const basicFieldsChanged = 
      safeCompare(reqNo, initialData.req_no) ||
      safeCompare(reqNote, initialData.req_note) ||
      safeCompare(reqDate, initialData.req_date?.split(' ')[0]) ||
      safeCompareNumbers(fromWarehouse, initialData.warehouse_id) ||
      safeCompare(reqType, initialData.req_type) ||
      safeCompare(subAccount, initialData.sub_account);

    // Special handling for toWarehouse in TRANS type
    const toWarehouseChanged = reqType === 'TRANS' && 
      safeCompareNumbers(toWarehouse, initialData.warehouse_id_to);

    // Compare rows with their initial values
    const initialDetails = initialData.details || [];
    
    // First check if the number of rows has changed
    if (rows.length !== initialDetails.length) {
      return true;
    }

    const rowsChanged = rows.some((row, index) => {
      const initialRow = initialDetails[index];
      if (!initialRow) return true;

      return (
        safeCompare(row.product_id, initialRow.product_id) ||
        safeCompareNumbers(row.quantity, initialRow.qty) ||
        safeCompareNumbers(row.unitPrice, initialRow.cost) ||
        safeCompareNumbers(row.total, initialRow.total)
      );
    });

    // Check if a file was added
    const fileChanged = reqAttach !== null;

    const hasChanges = basicFieldsChanged || toWarehouseChanged || rowsChanged || fileChanged;



    return hasChanges;
  };

  useEffect(() => {
    if (initialData) {
      const isChanged = isModified();
   
      setHasChanges(isChanged);
    }
  }, [
    reqNo,
    reqNote,
    reqDate,
    reqType,
    fromWarehouse,
    toWarehouse,
    subAccount,
    reqAttach,
    rows,
    initialData,
  ]);
  const { deleteItem, loading: deleteLoading, error: deleteError } = useDeleteWBody();
  const {
    location,
    loading: uploadLoading,
    error: uploadError,
    handleUpload
} = useUploadFile(['image/png', 'image/jpeg', 'image/gif', 'image/webp', 'application/pdf', 'image/svg+xml', 'image/bmp', 'image/tiff'], 'requisitions');
  useEffect(() => {
    if (location) {
      setFileKey(location);
      setFileLocation(location);
      setSelectedFile({
        name: reqAttach?.name || 'Uploaded file',
        type: reqAttach?.type || 'application/octet-stream',
        url: location
      });
    }
  }, [location]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setReqAttach(file);
      handleUpload(e);
    }
  };

  const handleRemoveFile = async () => {
    if (fileKey) {
      try {
        await deleteItem(process.env.REACT_APP_UPLOADS_API_BASE_URL ,  {keyFile: fileKey});
        URL.revokeObjectURL(selectedFile?.url);
        setSelectedFile(null);
        setReqAttach(null);
        setFileKey(null);
        setFileLocation(null);
        
        // Reset the file input
        const fileInput = document.getElementById('file_upload');
        if (fileInput) {
          fileInput.value = '';
        }
      } catch (error) {
        toast.error('حدث خطأ أثناء حذف الملف', {
          position: "top-center",
          autoClose: 3000,
          rtl: true,
          theme: "colored",
        });
      }
    }
  };
 


useEffect(() => {
  if (putError) {
    // Check if the error message includes 'duplicate' to show specific message
    if (putError.message?.includes('exists')) {
      toast.error(t('requisition.duplicate_number'), {
        position: "top-center",
        autoClose: 3000,
        rtl: isRTL,
        theme: "colored",
      });
    } else {
      // Show general error message
      toast.error(putError.message || t('deleted.error_fetching_data'), {
        position: "top-center",
        autoClose: 3000,
        rtl: isRTL,
        theme: "colored",
      });
    }
  }
}, [putError, isRTL, t]);

 

useEffect(() => {
    if (putdata) {
      if (putdata.status === 1) {
        toast.success(  t('deleted.data_updated_successfully')  , {
          position: "top-center",
          autoClose: 3000,
          rtl: true,
          theme: "colored",
        });
        // Reset form or redirect here if needed
        setTimeout(() => {
          navigate(`/${tenant}/requisition`);
        }, 1500);
      } else {
        toast.error(putError||   t('deleted.error_fetching_data')  , {
          position: "top-center",
          autoClose: 3000,
          rtl: true,
          theme: "colored",
        });
      }
    }
  }, [putdata, putError]);

const handleCancel = () => {
  navigate(`/${tenant}/requisition`);
};

 

  // Styles for inputs and labels
  const inputStyles = `w-full p-2 border border-gray-200 rounded-md text-[#251658] font-medium focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500  bg-white text-sm ${isRTL ? 'text-right' : 'text-left'}`;
  const labelStyles = `block text-sm mb-1 text-[#251658] font-medium ${isRTL ? 'text-right' : 'text-left'}`;
  const smallInputStyles = `w-full p-1.5 border border-gray-200 rounded-md text-[#251658] text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500  bg-white ${isRTL ? 'text-right' : 'text-left'}`;
  const centeredInputStyles = `${smallInputStyles} text-center`;
console.log("subAccount" ,subAccount);

if (requisitionLoading || warehousesLoading || !requisitionData || !warehousesData) {
  return (
    <div className="flex justify-center items-center h-[calc(100vh-100px)] bg-slate-100">
      <MwSpinner size="lg" />
    </div>
  );
}

  return (
    <div  className={` bg-white  rounded-lg  h-[calc(100vh-100px)] overflow-y-scroll custom-scrollbar`}
    dir={isRTL ? 'rtl' : 'ltr'}>
<ToastContainer
    position="top-center"
    autoClose={3000}
    hideProgressBar={false}
    newestOnTop
    closeOnClick
    rtl={isRTL}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    theme="colored"
    style={{ top: '60px' }}  
/>
          <CardHeadeWithActions title={
            <>
             {reqType === 'TRANS' && <FaExchangeAlt className="inline-block mx-2" />}
             {reqType === 'PASH' && <FaArrowDown className="inline-block mx-2" />}
             {reqType === 'PULL' && <FaArrowUp className="inline-block mx-2" />}
            {reqType === 'TRANS'
         ? t('requisition._transfer')
         : reqType === 'PASH'
         ? t('requisition._receive')
         : reqType === 'PULL'
         ? t('requisition._issue')
         : t('requisition.type')}
            </> 
                      }>

 
              <MwButton
                actionType="button"
                inGroup={true} 
                type="saveBtn"  
                onClick={handleCancel}
                disabled={ putLoading }
                classNameCustom={putLoading ? "opacity-50 cursor-not-allowed" : ""}
              >
                 {t('requisition.requisition_list')}
              </MwButton>
             
      
        </CardHeadeWithActions>
        <div className='bg-white w-[98%] mx-auto rounded-lg shadow-sm  '>
      <div className='flex justify-end mt-3 '>

        <MwButton
        actionType="button"
        inGroup={true}
        type="saveBtn"
        size='sm'
        onClick={handleUpdate}
        disabled={
          requisitionLoading || 
          !initialData || 
          !isModified() || 
          !validateFields() || 
          putLoading ||
          (reqType === 'TRANS' && !toWarehouse) // Additional check
        }
        classNameCustom={
          requisitionLoading || 
          !initialData || 
          !isModified() || 
          !validateFields() || 
          putLoading ||
          (reqType === 'TRANS' && !toWarehouse)
            ? "opacity-50 cursor-not-allowed" 
            : ""
        }
      >
        {putLoading ? (
          <span>جار التحديث...</span>
        ) : (
          <>
            <FaRegSave />
            {t('requisition.update')}
          </>
        )}
      </MwButton>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
  {/* Warehouse and Requisition Details */}
  <div className="bg-gray-50 p-6 mt-3  rounded-lg  ">
   
      <h5 className={`${isRTL ? 'text-right' : 'text-left'} text-[#251658] mb-4 font-bold text-sm`}>
        {t('requisition.requisition_information')}
      </h5>
      {/* تقسيم الحقول إلى عمودين بنفس العرض مع فجوة */}
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className={labelStyles}>{t('requisition.type')}</label>
          <input
            type="text"
            value={
              reqType === 'TRANS'
                ? t('requisition._transfer')
                : reqType === 'PASH'
                ? t('requisition._receive')
                : reqType === 'PULL'
                ? t('requisition._issue')
                : t('requisition.type')
            }
            className={`${inputStyles} w-full`}
            readOnly
          />
        </div>

        <div>
          <label className={labelStyles}>{t('requisition.date')}</label>
          <input
            type="date"
            value={reqDate}
            onChange={(e) => setReqDate(e.target.value)}
            className={`${inputStyles} w-full`}
          />
        </div>
      </div>
    
  </div>

  {/* Warehouse Selection */}
  <div className="bg-gray-50 p-6 mt-3 rounded-lg  ">
     
      <h5 className={`${isRTL ? 'text-right' : 'text-left'} text-[#251658] mb-4 font-bold text-sm`}>
        {t('requisition.Store_Information')}
      </h5>
      {/* إذا كان reqType === 'TRANS' نعرض حقلي "من" و"إلى" جنبًا إلى جنب، وإلا نعرض حقل "من" فقط */}
      <div className={`grid ${reqType === 'TRANS' ? 'grid-cols-2 gap-3' : 'grid-cols-1'}`}>
        <div>
          <label className={labelStyles}>{t('requisition.from')}</label>
          {warehousesLoading ? (
            <div className="p-2 text-gray-500 text-sm">جاري التحميل...</div>
          ) : warehousesError ? (
            <div className="p-2 text-red-500 text-sm">{t('deleted.error_fetching_data')}</div>
          ) : warehouses && warehouses.length > 0 ? (
            <MwSelector
              withSearch={false}
              _data={warehouses.map((warehouse) => ({
                _id: warehouse.id,
                label: warehouse.name_ar,
                value: warehouse.id,
              }))}
              dataType="labelValue"
              setSelectedItem={(item) => setFromWarehouse(item.value)}
              selectedItem={
                fromWarehouse
                  ? {
                      _id: fromWarehouse,
                      label: warehouses.find((w) => w.id === parseInt(fromWarehouse))?.name_ar,
                      value: fromWarehouse,
                    }
                  : null
              }
              initalValue="اختر..."
              withLabel={false}
            />
          ) : (
            <div className="p-2 text-gray-500 text-sm">{t('deleted.no_data')}</div>
          )}
        </div>

        {reqType === 'TRANS' && (
          <div>
            <label className={labelStyles}>{t('requisition.to')}</label>
            {warehousesLoading ? (
              <div className="p-2 text-gray-500 text-sm">جاري التحميل...</div>
            ) : warehousesError ? (
              <div className="p-2 text-red-500 text-sm">{t('deleted.error_fetching_data')}</div>
            ) : warehouses && warehouses.length > 0 ? (
              <MwSelector
                withSearch={false}
                _data={warehouses
                  .filter((warehouse) => warehouse.id !== parseInt(fromWarehouse))
                  .map((warehouse) => ({
                    _id: warehouse.id,
                    label: warehouse.name_ar,
                    value: warehouse.id,
                  }))}
                dataType="labelValue"
                setSelectedItem={(item) => setToWarehouse(item.value)}
                selectedItem={
                  toWarehouse
                    ? {
                        _id: toWarehouse,
                        label: warehouses.find((w) => w.id === parseInt(toWarehouse))?.name_ar,
                        value: toWarehouse,
                      }
                    : null
                }
                initalValue="اختر..."
                withLabel={false}
              />
            ) : (
              <div className="p-2 text-gray-500 text-sm">{t('deleted.no_data')}</div>
            )}
          </div>
        )}
      </div>
    </div>
  </div>
 


  <div className="bg-gray-50 p-6 mt-3 rounded-lg">
  <h5
    className={`${isRTL ? 'text-right' : 'text-left'} text-[#251658] mb-4 font-bold text-sm`}
  >
    {t('requisition.item_details')}
  </h5>

  {/* Column Headers */}
  <div
    className="mb-2 text-xs text-[#251658]"
    style={{
      display: 'grid',
      gridTemplateColumns: '0.5fr 6.5fr 1fr 1fr 1fr 1fr 2fr',
      gap: '0.5rem'
    }}
  >
    <div className="text-center text-xs">#</div>
    <div className={`${isRTL ? 'text-right' : 'text-left'}`}>
      {t('requisition.item')}
    </div>
    <div className="text-center">{t('requisition.purchase_price')}</div>
    <div className="text-center">{t('requisition.quantity')}</div>
    <div className="text-center">{t('requisition.balance_before')}</div>
    <div className="text-center">{t('requisition.balance_after')}</div>
    <div className="text-center">{t('requisition.total')}</div>
  </div>

  {/* Rows */}
  {rows.map((row, index) => (
    <div
      key={index}
      className={`text-[#251658] items-center relative mb-4 ${
        index === rows.length - 1 ? '' : 'border-b border-gray-300 pb-2'
      }`}
      style={{
        display: 'grid',
        gridTemplateColumns: '0.5fr 6.5fr 1fr 1fr 1fr 1fr 2fr',
        gap: '0.5rem'
      }}
    >
      {/* عمود الرقم */}
      <div className="text-center text-xs">{index + 1}</div>

      {/* عمود البند */}
      <div>
        <MwSelectorProduct
          onChangeCallback={(selectedProduct) =>
            handleProductSelect(selectedProduct, index)
          }
          withLabel={false}
          value={row.item || ""}
          initalValue={row.item || ""}
          disabled={false}
          inputStyle={{
            color: 'black',
            textAlign: isRTL ? 'right' : 'left',
            padding: '0.5rem 1rem'
          }}
        />
      </div>

      {/* عمود السعر */}
      <div>
        <input
          type="number"
          value={row.unitPrice || ''}
          onChange={(e) =>
            handleInputChange(index, 'unitPrice', e.target.value)
          }
          className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md text-center focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
        />
      </div>

      {/* عمود الكمية */}
      <div>
        <input
          type="number"
          value={row.quantity}
          onChange={(e) =>
            handleInputChange(index, 'quantity', e.target.value)
          }
          className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md text-center focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
        />
      </div>

      {/* عمود الرصيد قبل */}
      <div>
        <input
          type="text"
          value={formatNumber(row.balanceBefore)}
          readOnly
          className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md text-center bg-gray-50"
        />
      </div>

      {/* عمود الرصيد بعد */}
      <div>
        <input
          type="text"
          value={formatNumber(row.balanceAfter)}
          readOnly
          className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md text-center bg-gray-50"
        />
      </div>

      {/* عمود الإجمالي وزر الحذف */}
      <div className="flex items-center gap-2">
        <input
          type="text"
          value={formatNumber(row.total)}
          readOnly
          className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md text-center bg-gray-50 font-medium"
        />
        <button
          onClick={() => removeRow(index)}
          className="text-red-500 hover:text-red-700 p-2 rounded-full hover:bg-red-100 transition-colors"
        >
          <FaTimes className="text-sm" />
        </button>
      </div>
    </div>
  ))}

  {/* Footer Section */}
  <div className="mt-8 space-y-6">
    {/* Add Row Button */}
    <div className="flex justify-start">
      <MwButton
        actionType="button"
        inGroup={true}
        type="saveBtn"
        onClick={addRow}
        size="sm"
      >
        <FaPlus className="text-base" />
        {t('requisition.add_row')}
      </MwButton>
    </div>

    {/* Total Summary Section */}
    <div className="border-t border-gray-200 pt-3">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-8" />
        <div className="col-span-4">
          <div className="space-y-3">
            <h3 className="text-[#251658] font-semibold text-right text-sm">
              {t('requisition.total_summary')}:
            </h3>
            <input
              type="text"
              value={formatNumber(
                rows.reduce((sum, row) => sum + row.total, 0)
              )}
              readOnly
              className="w-full px-2 py-1 text-base border-2 border-gray-300 rounded-lg bg-gray-50 font-bold text-gray-800 text-center shadow-sm"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>




      {/* Additional Information */}
      <div className="bg-gray-50 p-6 mt-3 rounded-lg  ">
        
        <h5 className={`${isRTL ? 'text-right' : 'text-left'} text-[#251658] mb-4 font-bold text-sm`}>            {t('requisition.account_info')}  </h5>
          <div className="space-y-4">
            <div className={`grid ${reqType === 'TRANS' ? 'grid-cols-1' : 'grid-cols-2'} gap-4`}>
              {reqType !== 'TRANS' && (
                     <div>
                     <label className={labelStyles} > {t('requisition.sub_account')}  </label>
                     <OsMwSelectorAccount
             onChangeCallback={(selectedAccount) => {
            setSubAccount(selectedAccount.account_no);
               }}
             withLabel={false}
             initalValue={subAccount}
             />
                   </div>
               
              )}
              <div className={reqType === 'TRANS' ? 'col-span-1 ' : ''}>
                <label className={labelStyles}>{t('requisition.number')}</label>
                <input
                style={{textAlign: 'center'}}
                  type="text"
                  className={`${inputStyles}`}
                  value={reqNo}
                  onChange={(e) => setReqNo(e.target.value)}
                />
              </div>
            </div>

         
          </div>
       
      </div>

      {/* Additional Information */}
      <div className="bg-gray-50 p-6 mt-3 rounded-lg  ">
        
        <h5 className={`${isRTL ? 'text-right' : 'text-left'} text-[#251658] mb-4 font-bold text-sm`}>             {t('requisition.other_info')}  </h5>
          <div className="space-y-4">

           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className={labelStyles}>{t('requisition.notes')}</label>
                <textarea
                  className={`${inputStyles} min-h-[85px]`}
                  value={reqNote}
                  placeholder={t('requisition.enter_notes')}
                  onChange={(e) => setReqNote(e.target.value)}
                />
              </div>
              <div>
  <label className={labelStyles}>{t('requisition.attachments')}</label>
  <div className="border-2 border-dashed border-gray-300 rounded-lg p-4  bg-white">
    <MwInputFile
      onChangeHandler={handleFileChange}
      acceptTypes="image/*,.webp,.svg,.bmp,.tiff,application/pdf,.pdf"

      label="اضغط على الملف هنا او اختر من جهازك"
      id="file_upload"
      isMultiple={false}
      isSmall={false}
      disabled={uploadLoading}
    />
    {selectedFile && (
      <div className="mt-4">
        <div className="flex items-center justify-between mb-2">
          <p className="text-sm text-[#251658]"> {t('requisition.selected_file')}  : {selectedFile.name}</p>
          <button
            onClick={handleRemoveFile}
            className="p-1 hover:bg-red-50 rounded-full text-red-500 hover:text-red-700 transition-colors"
            title="إلغاء الملف"
            disabled={deleteLoading}
          >
            <FaTimes size={16} />
          </button>
        </div>
        {selectedFile.type.startsWith('image/') || selectedFile.name.toLowerCase().endsWith('.webp')? (
          <img src={selectedFile.url} alt="Preview" className="max-w-xs mx-auto" />
        ) : selectedFile.type === 'application/pdf' && (
          <div className="flex items-center justify-center">
            <iframe 
              src={selectedFile.url} 
              className="w-full h-[300px]" 
              title="PDF Preview"
            ></iframe>
          </div>
        )}
      </div>
    )}
  </div>
</div>
            </div>
          </div>
        
      </div>
      </div>
    </div>
  );
};


export default OsRequisitionViewUpdate;;;